export enum USER_ROLE {
  EMPLOYEE = 1,
  SECURITY = 2,
  FUNCTIONAL_SUPPORT = 3,
  ADMIN = 4,
}

export enum BadgeType {
  INTERNAL = 'interne',
  EXTERNAL = 'externe',
}


export enum UserFunction {
  EMPLOYEE = 1,
  EB = 2,
  BOARD = 3
}